module.exports = __webpack_public_path__ + "img/responsive-water.0f3f67f7.png";